export default "__VITE_ASSET__b1bab1b5__"